import React, {  } from 'react';
import {
  FieldDatepicker,
  FieldInput,
  FormCol,
  FormRow,
} from 'motion-components';
import {
  FieldSelectDriver,
  FieldSelectVehicle,
} from 'shared-pages/components';
import { useFormikContext } from 'formik';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { useTranslation } from 'react-i18next';
import { isActiveField } from 'shared-pages/common/form-helpfunc';
import { RouteLinesTable } from './routeLines-table';
import { RouteStatusBadge } from '../route-status-badge';
import RouteCompleteButton from '../routeCompleteButton';
import { RouteStates } from 'shared-pages/shared/constants';

const FormFields = ({ isNew }: any) => {
  const frmkCntx = useFormikContext();
  const { values, setFieldValue, dirty }: any = frmkCntx;
  const { authStore, appStore } = useRootStore();
  const { t } = useTranslation();
  const collectorId = appStore.associatedId;

  const { handleGraphqlError } = useHandleError('OrderFormFields');
  function calcUserCanEdit() {
    const canEdit =
      isNew ||
      ((appStore.isPlatformOwner || appStore.isCollector) &&
        values?.statusId === RouteStates.Planned);
    const canEditReasoning = '';
    return { canEdit, canEditReasoning };
  }
  const { canEdit, canEditReasoning } = calcUserCanEdit();

  return (
    <div>
      <FormRow>
        {/* First Row */}
        <FormCol className="col-md">
          <FieldInput
            label={t('Κωδικός')}
            name="code"
            placeholder={t('Αφήστε κενό για να συμπληρωθεί αυτόματα')}
            disabled={!isNew}
          />
        </FormCol>
        <FormCol className="col-md">
          <FieldSelectVehicle collectorId={collectorId} disabled={!canEdit} />
        </FormCol>
        <FormCol className="col-md">
          <FieldDatepicker
            label={t('Ημερομηνία Δρομολογίου')}
            name="routeDate"
            disabled={!canEdit}
          />
        </FormCol>

        <FormCol className="col-md">
          {isNew ? (
            <></>
          ) : (
            <div className="d-flex flex-column align-items-start ">
              <span className="mb-1">{t('Κατάσταση :')}</span>
              <RouteStatusBadge id={values.statusId} name={values?.state?.name} />
            </div>
          )}
        </FormCol>
      </FormRow>
      <FormRow>
        {/* Second Row */}
        <FormCol className="col-md">
          <FieldInput label={t('Σημειώσεις')} name="notes" placeholder="" disabled={!canEdit} />
        </FormCol>
        <FormCol className="col-md">
          <FieldSelectDriver collectorId={collectorId} disabled={!canEdit} />
        </FormCol>
        <FormCol>
          {values?.dateCompleted && (
            <FieldDatepicker
              label={t('Ημερομηνία Ολοκλήρωσης')}
              name="dateCompleted"
              disabled={!canEdit}
            />
          )}
        </FormCol>
        <FormCol>{isNew ? <></> : isActiveField(t, canEdit)}</FormCol>
      </FormRow>
      <FormRow>
        <FormCol className="col-md">
          {' '}
          {!!values?.vehicle?.collector?.id && (
            <FieldInput
              label={t('Συλλέκτης')}
              name="vehicle.collector.name"
              placeholder=""
              disabled={!canEdit}
            />
          )}
        </FormCol>
        <FormCol></FormCol>
        <FormCol className="col-md"></FormCol>
        <FormCol className="col-md d-flex align-items-center">
          {/* Κουμπί Ολοκλήρωσης Δρομολογίου */}
          {values?.id && values?.statusId === RouteStates.Planned && (
            <RouteCompleteButton
              route={values}
              disabled={
                values?.statusId === RouteStates.Executed ||
                (values?.routesLines?.length ?? 0) === 0
              }
            />
          )}
        </FormCol>
      </FormRow>
      {/* Σημεία Δρομολογίου */}
      <div className="mt-2 mb-5">
        {values ? (
          <RouteLinesTable
            collector={values?.vehicle?.collector}
            statusId={values?.statusId}
            id={values?.id}
            isNew={isNew}
          />
        ) : null}
      </div>
    </div>
  );
};

export default FormFields;
